// extracted by mini-css-extract-plugin
export default {"cls1":"Spinner-cls1_VDP","cls2":"Spinner-cls2__84 Spinner-cls1_VDP","rotate-spinner":"Spinner-rotate-spinner_AOU"};